module.exports = __webpack_public_path__ + "img/Hannah Golding.809c9a4c.jpg";